<!-- <div class="title-list">
  <h2>{{currentModule}}</h2>
</div> -->

<div class="container-fluid">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="simple-container">
        <div class="master-container">
          <div class="subtitle-list" *ngIf="tableTitle">
            <h5>{{ tableTitle }}</h5>
          </div>
          <div class="row">
            <div class="col-12">
              <button mat-raised-button style="background-color: var(--app-success); color: white;"
                class="btn btn-success"
                (click)="sendNotiToUsers()"
              >
              <mat-icon>campaign</mat-icon>
              Enviar Notificación
              </button>
            </div>
          </div>
          <br>
          <div class="row no-gutters">
            <div class="col-12">
              <div class="input-group mb-3 filter-form">
                <input type="text" class="form-control" placeholder="Ingresa un valor para buscar en la tabla..."
                       [(ngModel)]="searchKey" (keyup)="applyFilter()">
                <button mat-button matSuffix mat-icon-button aria-label="Clear" class="clear-bnt" *ngIf="searchKey"
                        (click)="onSearchClear()">
                  <mat-icon>close</mat-icon>
                </button>
                <div class="input-group-append">
                  <button mat-raised-button class="btn btn-info"
                          style="background-color: var(--app-primary-dark); color: white;"
                          type="button" (click)="applyFilter()">
                    <i class="material-icons">find_in_page</i>
                  </button>
                </div>
                &nbsp;
                <button mat-raised-button style="width: 80px;" matTooltip="Filtros" (click)="select.open()">Filtro
                  <mat-icon>
                    filter_alt
                  </mat-icon>
                  <mat-select class="custom-filter" #select multiple (selectionChange)="checkDisplayColumns()"
                              [(ngModel)]="columns">
                    <mat-option *ngFor="let column of listOfColumns"
                                [value]="column">{{transFormText(column)}}</mat-option>
                  </mat-select>
                </button>
              </div>

            </div>
          </div>
          <!--botones para filtrar -->


          <div class="mat-elevation-z8 table-container">
            <mat-table [dataSource]="listUsers" matSort>


              <!-- Checkbox Column -->
              <ng-container matColumnDef="select">
                <mat-header-cell *matHeaderCellDef>
                  <mat-checkbox (change)="$event ? masterToggle() : null"
                                [checked]="selection.hasValue() && isAllSelected()"
                                [indeterminate]="selection.hasValue() && !isAllSelected()"
                                >
                  </mat-checkbox>
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                  <mat-checkbox (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(row) : null"
                                [checked]="selection.isSelected(row)"
                                >
                  </mat-checkbox>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="id" *ngIf="currentModule !== 'groups'">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Id</mat-header-cell>
                <mat-cell *matCellDef="let element">{{element.id}}</mat-cell>
              </ng-container>
              <!-- id -->

              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</mat-header-cell>
                <mat-cell *matCellDef="let element" class="selector" (click)="showUsrProfile(element)">{{element.name}}</mat-cell>
              </ng-container>
              <!-- name -->

              <ng-container matColumnDef="lastname">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Apellidos</mat-header-cell>
                <mat-cell *matCellDef="let element" class="selector" (click)="showUsrProfile(element)">{{element.lastname}}</mat-cell>
              </ng-container>
              <!--lastname-->

              <ng-container matColumnDef="email" *ngIf="currentModule !== 'groups'">
                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'users.email' | translate}}</mat-header-cell>
                <mat-cell class="email-row" *matCellDef="let element">{{element.email}}</mat-cell>
              </ng-container>
              <!--email-->

              <ng-container matColumnDef="telephone">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Teléfono</mat-header-cell>
                <mat-cell *matCellDef="let element">{{element.telephone}}</mat-cell>
              </ng-container>
              <!--telephone-->

              <ng-container matColumnDef="active" *ngIf="currentModule !== 'groups'">
                <mat-header-cell *matHeaderCellDef mat-sort-header>Estatus</mat-header-cell>
                <mat-cell *matCellDef="let element">{{(element.active && element.active === true) ?  'Activo' : 'Inactivo'}}</mat-cell>
              </ng-container>
              <!--active-->

              <ng-container matColumnDef="actions" style="flex-wrap: wrap !important;">
                <mat-header-cell *matHeaderCellDef>Acciones</mat-header-cell>
                <mat-cell *matCellDef="let row">

                  <button *ngIf="showButton('food-qualification') === true" mat-icon-button color="primary" (click)="showUsrFoods(row)" matTooltip="Ver comidas del participante">
                    <mat-icon>local_dining</mat-icon>
                    <span>Comidas</span>
                  </button>

                  <button *ngIf="showButton('body-qualification') === true" mat-icon-button color="primary" (click)="showUsrBodies(row)" matTooltip="Ver imagenes de cuerpo completo del participante">
                    <mat-icon>accessibility</mat-icon>
                    <span>Img. Cuerpo</span>
                  </button>

                  <button *ngIf="showButton('user-notifications') === true" mat-icon-button color="primary" (click)="showUsrNotifications(row)" matTooltip="Ver notificaiones enviadas">
                    <mat-icon>notifications_active</mat-icon>
                    <span>Notificaciones</span>
                  </button>

                  <button *ngIf="showButton('add-user-group') === true" mat-icon-button color="primary" (click)="emitSelectedUser(row)" matTooltip="Agregar Usuario al grupo">
                    <mat-icon>how_to_reg</mat-icon>
                    <span>OK Agregar</span>
                  </button>

                   <button *ngIf="showButton('remove-user-group') === true" mat-icon-button color="warn" (click)="rmFromGroup(row)" matTooltip="Expulsar usuario del grupo">
                    <mat-icon>cancel</mat-icon>
                    <span>Expulsar</span>
                  </button>

                </mat-cell>
              </ng-container>


              <ng-container matColumnDef="init">
                <mat-footer-cell *matFooterCellDef colspan="8" style="color: var(--app-primary-dark); font-weight: 400;">
                  Ingrese un valor usando la entrada de búsqueda ubicada en la parte superior
                </mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="noData">
                <mat-footer-cell *matFooterCellDef colspan="8" style="color: #2196F3">
                  No se encontraron registros
                </mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="loading">
                <mat-footer-cell *matFooterCellDef colspan="8">
                  <mat-spinner [diameter]="40"></mat-spinner>
                </mat-footer-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

              <mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{hide: spinner === false}"></mat-footer-row>
              <mat-footer-row *matFooterRowDef="['init']" [ngClass]="{'hide':listUsers!=null || spinner === true}">
              </mat-footer-row>
              <mat-footer-row *matFooterRowDef="['noData']"
                              [ngClass]="{hide:!(listUsers!=null && listUsers.data.length==0)}"></mat-footer-row>
            </mat-table>
            <mat-paginator style="overflow: inherit !important;" [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="15"
                           showFirstLastButtons></mat-paginator>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
